import { Injectable, signal, computed } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SongDrawerService {
  readonly activeSongId = signal<string | null>(null);
  readonly isOpen = computed(() => this.activeSongId() !== null);

  /**
   * Open the preview drawer for the given song ID.
   */
  open(songId: string | number): void {
    const resolved = String(songId).trim();
    if (resolved) {
      this.activeSongId.set(resolved);
    }
  }

  /**
   * Close the preview drawer.
   */
  close(): void {
    this.activeSongId.set(null);
  }
}
